import React from 'react'
import { CheckCircle } from 'lucide-react'
import Button from '../components/Button'
import { Link } from 'react-router-dom'

const AccountActivated: React.FC = () => {

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
        <CheckCircle className="mx-auto text-green-500 w-12 h-12 mb-4" />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Account Activated!
        </h1>
        <p className="text-gray-600 mb-6">
          Your account has been successfully activated.
        </p>
        <div className="flex items-center justify-center">
          <Link to={`/login`}>
            <Button
              className="bg-gray-900 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-300 ease-in-out"
              text="Proceed to Login"
              size="small"
              shade="dark"
              buttonType="primary"
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AccountActivated
